var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-img-card"},[_c('div',{staticClass:"img"},[_c('l-img',{attrs:{"src":_vm.src}})],1),_c('h4',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }